import React from 'react'
import { Currency } from "../../shared/Currency";

export const CurrencyField = ({ col, row, tableType, fieldName }) => {
    return <Currency value={col} />;
};
